module.exports = __webpack_public_path__ + "img/lbc.d9b432f8.jpg";